import { render, staticRenderFns } from "./TableChamados.vue?vue&type=template&id=3698c278&scoped=true&"
import script from "./TableChamados.vue?vue&type=script&lang=js&"
export * from "./TableChamados.vue?vue&type=script&lang=js&"
import style0 from "./TableChamados.vue?vue&type=style&index=0&id=3698c278&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698c278",
  null
  
)

export default component.exports